import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
export default {
  __name: 'AdvertLaunchBaseInfo',
  props: {
    advertLaunch: {
      type: Object
    },
    roleFlag: {
      type: String,
      default: ""
    },
    currentAction: {
      type: String,
      default: ""
    }
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      const _component_el_descriptions_item = _resolveComponent("el-descriptions-item");
      const _component_el_descriptions = _resolveComponent("el-descriptions");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_descriptions, {
        title: "基本信息"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_descriptions_item, {
          label: "任务名称"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.advertLaunch.taskName), 1)]),
          _: 1
        }), _createVNode(_component_el_descriptions_item, {
          label: "执行公司"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.advertLaunch.opCompany), 1)]),
          _: 1
        }), _createVNode(_component_el_descriptions_item, {
          label: "执行人员"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.advertLaunch.opName), 1)]),
          _: 1
        }), _createVNode(_component_el_descriptions_item, {
          label: "合同编号"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.advertLaunch.contractCode), 1)]),
          _: 1
        }), _createVNode(_component_el_descriptions_item, {
          label: "合同名称"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.advertLaunch.contractName), 1)]),
          _: 1
        }), __props.advertLaunch.monitorCompany && __props.roleFlag == '2' ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
          key: 0,
          label: "监测公司"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.advertLaunch.monitorCompany), 1)]),
          _: 1
        })) : _createCommentVNode("", true), __props.advertLaunch.pickTime && __props.roleFlag == '2' && __props.currentAction != 'manyMonitor' ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
          key: 1,
          label: "认领时间"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.advertLaunch.pickTime), 1)]),
          _: 1
        })) : _createCommentVNode("", true), __props.advertLaunch.monitorTime && __props.roleFlag == '2' && __props.currentAction != 'manyMonitor' ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
          key: 2,
          label: "监测时间"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.advertLaunch.monitorTime), 1)]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      })]);
    };
  }
};